<script lang="ts">
	import { translationsStore } from '$lib/store/translations.store.js';

	let { data, children } = $props();

	translationsStore.set(data.translations);
</script>

{@render children?.()}

<svelte:head>
	<title>Learn More About Splitit</title>
</svelte:head>
